<template>
    <div class="detail-reply">
        <el-dialog title="回复详情" :visible.sync="visibleDialog">
            <el-form label-width="100px">
                <el-form-item label="关键词:">
                    <span>{{ detailInfo.keyword }}</span>
                </el-form-item>
                <el-form-item
                    label="图片标题"
                    v-if="detailInfo.msgType === 'news'"
                >
                    <span>{{ detailInfo.content.title }}</span>
                </el-form-item>
                <el-form-item
                    label="图片描述"
                    v-if="detailInfo.msgType === 'news'"
                >
                    <span>{{ detailInfo.content.description }}</span>
                </el-form-item>
                <el-form-item
                    label="跳转链接"
                    v-if="detailInfo.msgType === 'news'"
                >
                    <span>{{ detailInfo.content.url }}</span>
                </el-form-item>
                <el-form-item
                    label="回复图片:"
                    v-if="detailInfo.msgType === 'news'"
                >
                    <el-image
                        style="width: 100px; height: 100px"
                        :src="detailInfo.content.picUrl"
                        fit="fill"
                    ></el-image>
                </el-form-item>
                <el-form-item label="回复内容:" v-else>
                    <span>{{ detailInfo.content }}</span>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
// 引入过滤函数
import { showcontent } from "@/utils/method.js";
import cloneDeep from "lodash/cloneDeep";
export default {
    data() {
        return {
            visibleDialog: false,
            detailInfo: {},
        };
    },
    methods: {
        // 父组件调用的函数，初始化
        init(val) {
            this.visibleDialog = true;
            this.detailInfo = cloneDeep(val);
            this.detailInfo.content = showcontent(this.detailInfo.content);

            // 如果为图文类型，则将content值转化为json
            if (this.detailInfo.msgType === "news") {
                this.detailInfo.content = JSON.parse(this.detailInfo.content);
            }
        },
    },
};
</script>

<style lang="less" scoepd>
</style>